import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSportsData } from "../../redux/slicer/researchAndStudentSlice";
import Slider from "react-slick";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";
import CardDetails from "./sports_details";

function Sports() {
  const dispatch = useDispatch();

  // Get sports data from Redux store
  const { data: sportsData, loading, error } = useSelector(
    (state) => state.research.sports
  );

  useEffect(() => {
    dispatch(fetchSportsData()); // Fetch sports data when the component mounts
  }, [dispatch]);

  const [isOpenEdit, setIsOpenEdit] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);

  const openEditPopup = (card) => {
    setSelectedCard(card);
    setIsOpenEdit(true);
  };

  const closeEditPopup = () => {
    setSelectedCard(null);
    setIsOpenEdit(false);
  };

  const mainSliderSettings = {
    dots: true,
    infinite: sportsData.length > 1, // Disable infinite loop if there is only one card
    speed: 500,
    slidesToShow: sportsData.length >= 3 ? 3 : sportsData.length, // Show all cards if less than 3
    slidesToScroll: 1,
    arrows: true,
    prevArrow: (
      <div className="hidden md:block absolute top-1/2 left-0 transform -translate-y-1/2 bg-white p-2 rounded-full cursor-pointer z-10">
        <FaChevronLeft className="text-primary-color text-lg" />
      </div>
    ),
    nextArrow: (
      <div className="hidden md:block absolute top-1/2 right-0 transform -translate-y-1/2 bg-white p-2 rounded-full cursor-pointer z-10">
        <FaChevronRight className="text-primary-color text-lg" />
      </div>
    ),
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 2, arrows: false } },
      { breakpoint: 600, settings: { slidesToShow: 1, arrows: false } },
    ],
  };

  const imageSliderSettings = {
    dots: true,
    infinite: false, // Nested slider does not loop
    speed: 500,
    slidesToShow: 1, // Show one image per slide
    slidesToScroll: 1,
    arrows: false, // Disable arrows for nested slider
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  return (
    <div className="slider-container relative p-4">
      {/* Main Carousel for all cards */}
      <Slider {...mainSliderSettings}>
        {sportsData.map((card) => (
          <div key={card.id} className="p-4">
           <div className="rounded shadow-lg bg-white w-xs max-h-108 mx-auto flex flex-col">
              {/* Carousel for images within each card */}
              <Slider {...imageSliderSettings}>
                {card.files.length > 0 &&
                  card.files.map((image, index) => (
                    <div key={index}>
                      <img
                        className="rounded-t-lg  w-xs h-80 object-contain"
                        src={image}
                        alt={`Slide ${index + 1}`}
                      />
                    </div>
                  ))}
              </Slider>

              <div className="px-6 py-6 flex flex-col justify-between flex-1">
                <div className="font-bold text-primary-color text-justify mb-2 font-titillium">
                  {card.sport_activity}
                </div>
                {/* Truncated Description */}
                <p
                  className="text-black text-base text-justify line-clamp-3 font-inter"
                  style={{
                    display: "-webkit-box",
                    WebkitLineClamp: 3, // Limits to 3 lines
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {card.description}
                </p>

                {/* Read More Button */}
                <div className="mt-auto pt-2 text-left">
                  <button
                    onClick={() => openEditPopup(card)}
                    className="text-primary-color hover:underline"
                  >
                    Read More
                  </button>
                </div>
              </div>
            </div>
          </div>
        ))}
      </Slider>

      {/* Modal for Card Details */}
      {isOpenEdit && selectedCard && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
          <div className="bg-white p-6 rounded-lg relative max-w-lg w-full">
            <button
              type="button"
              onClick={closeEditPopup}
              className="absolute text-4xl top-4 right-4 text-gray-500 hover:text-black"
            >
              &times;
            </button>
            <CardDetails card={selectedCard} onClose={closeEditPopup} />
          </div>
        </div>
      )}
    </div>
  );
}

export default Sports;
